import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

/**
 * Componente que exibe o item do pacote selecionado
 * 
 * @param {object} props - Propriedades do componente
 * @param {string} props.planName - Nome do plano
 * @param {string} props.monthlyValue - Valor mensal
 * @param {string} props.annualValue - Valor anual
 * @param {function} props.t - Função de tradução
 * @param {object} props.theme - Tema do Material UI
 */
const PackageItem = ({ planName, monthlyValue, annualValue, t, theme }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        width: "100%",
        borderRadius: "5.677px",
        height: "65.177px",
        padding: "0px 15px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        [theme.breakpoints.down("sm")]: {
          height: "5rem",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          flexGrow: 1,
        }}
      >
        <Typography
          sx={{
            color: "#4d4d4d",
            fontWeight: 700,
            textTransform: "uppercase",
            fontSize: "15.086px",
            textAlign: "left",
          }}
        >
          {`${t("purchase.package_of")} ${planName}:`}
        </Typography>
        <Typography
          sx={{
            color: "#662d91",
            fontWeight: 700,
            textTransform: "uppercase",
            fontSize: "15.086px",
            textAlign: "left",
          }}
        >
          {`${monthlyValue} ${t("purchase.monthly_or")} ${annualValue} ${t("purchase.annual")}`}
        </Typography>
      </Box>
    </Paper>
  );
};

export default React.memo(PackageItem);